import React from 'react';
import { connect } from 'react-redux';

import { QUOTATION_INSURANCE_CARRIER_STATE } from '@/shared/constants/quotationInsuranceCarrierStates';
import InsuranceCarrierPackageDummyCard from './InsuranceCarrierPackageDummyCard';

const isInsuranceCarrierLoading = (packageQuotationState, percentProgress) => {
  if (packageQuotationState != null) {
    return (
      packageQuotationState === QUOTATION_INSURANCE_CARRIER_STATE.PENDING
      || packageQuotationState === QUOTATION_INSURANCE_CARRIER_STATE.STARTED
    );
  }
  return percentProgress < 100;
};

/**
 * Cards dummy de carga: solo mientras la aseguradora está en loading y aún no hay
 * ningún package en Redux. Cada package in progress sale del listado de packages.
 */
const DummyLoadingCards = ({ dummyPackages }) => (
  <>
    {dummyPackages.map((dummyPackage) => (
      <InsuranceCarrierPackageDummyCard key={dummyPackage.id} insuranceCarrier={dummyPackage.insurance_carrier} />
    ))}
  </>
);

const actions = {};

const mapStateToProps = (state) => {
  const dummyPackages = [];

  // IDS aseguradoras cotizadas
  const responses = state.comparationQuotation.insuranceCarriersResponses;
  const packages = state.globalQuotation.quotation.packages ?? [];

  if (responses) {
    Object.keys(responses).forEach((insuranceCarrierId) => {
      const insuranceCarrierResponse = responses[insuranceCarrierId];
      // Si no hay respuesta de la aseguradora, no se agrega dummy
      if (!insuranceCarrierResponse) return;

      // Si la aseguradora ya no está en loading, no se agrega dummy
      if (!isInsuranceCarrierLoading(insuranceCarrierResponse.packageQuotationState, insuranceCarrierResponse.percent_progress)) {
        return;
      }

      const hasAnyPackageForInsuranceCarrier = packages.some(
        (insurancePackage) => String(insurancePackage.insurance_carrier) === String(insuranceCarrierId),
      );

      // Si ya hay package en Redux, no se agrega dummy (evita duplicar la card in progress del listado)
      if (hasAnyPackageForInsuranceCarrier) {
        return;
      }

      const insurance_carrier = state.initialData.aseguradoras.find(
        (aseguradora) => String(aseguradora.id) === String(insuranceCarrierId),
      );

      dummyPackages.push({
        id: `dummy-package--${insurance_carrier?.id ?? insuranceCarrierId}`,
        insurance_carrier,
      });
    });
  }

  return { dummyPackages };
};

export default connect(mapStateToProps, actions)(DummyLoadingCards);
